<ng-container *ngIf="isoAuthRedirection">
  <div class="auth-page-redirection spinner block mt-9 m-auto"></div>
</ng-container>
<app-checkout-layout
  *ngIf="!isoAuthRedirection"
  [title]="translateKey('title')"
  [backLinkAriaLabel]="translateKey('back_link')"
  [backLink]="backLink"
  data-test="subscription-page"
>
  <div>
    <h3 class="text-l">
      {{ activity?.name }}
    </h3>
    <app-timeslot
      [activity]="activity"
      [timeslot]="timeslot"
    >
      <ng-container price-badge-right>
        <app-badge>
          {{ offer.price | displayPrice: offer.currency }}
        </app-badge>
      </ng-container>
    </app-timeslot>
    <p class="text-xs">
      {{ activity.address }}
    </p>
  </div>

  <app-divider class="block my-6"></app-divider>

  <p class="text-sm text-grey mb-3">
    {{ translateKey('description.label') }}
  </p>

  <div class="subscription">
    <form
      class="subscription__form"
      [formGroup]="subscriptionForm"
      (ngSubmit)="onSubmit()"
    >
      <div *ngIf="item" class="subscription__form__container">
        <!-- Adults -->
        <div
          *ngIf="isAllowed('adultsAllowed')"
          class="subscription__form__fieldset"
        >
          <app-input-counter
            formControlName="numberOfAdults"
            name="number-of-adults"
            [label]="translateKey('number_of_adults.label')"
            [help]="translateKey('number_of_adults.help', {
              majorityAge: majorityAge,
            })"
            [max]="adultsMaxCapacity"
            data-test="input-counter-adult"
          ></app-input-counter>

          <ng-container *ngIf="!isEvent">
            <fieldset
              class="mt-4"
              *ngFor="let adult of adults.controls; index as adultIndex"
              [formGroup]="adult"
            >
              <legend class="subscription__form__title">
                {{
                  translateKey('adults.name.label', {
                    index: adultIndex + 1,
                  })
                }}
              </legend>

              <div class="subscription__form__control__container">
                <!-- Adult firstname -->
                <app-form-input-group
                  class="subscription__form__control subscription__form__control--firstname"
                  [label]="translateKey('adult.firstname.label')"
                  [errors]="errors('adults', 'firstname', adultIndex)"
                  errorKey="firstname"
                >
                  <app-form-input
                    #content
                    formControlName="firstname"
                    [placeholder]="translateKey('adults.firstname.placeholder')"
                    [required]="true"
                    data-test="input-firstname-adult"
                  ></app-form-input>
                </app-form-input-group>

                <!-- Adult lastname -->
                <app-form-input-group
                  class="subscription__form__control subscription__form__control--lastname"
                  [label]="translateKey('adult.lastname.label')"
                  [errors]="errors('adults', 'lastname', adultIndex)"
                  errorKey="lastname"
                >
                  <app-form-input
                    #content
                    formControlName="lastname"
                    [placeholder]="translateKey('adults.lastname.placeholder')"
                    [required]="true"
                    data-test="input-lastname-adult"
                  ></app-form-input>
                </app-form-input-group>
              </div>
            </fieldset>
          </ng-container>
        </div>

        <!-- Children -->
        <div
          *ngIf="isAllowed('childrenAllowed')"
          class="subscription__form__fieldset"
        >
          <app-input-counter
            formControlName="numberOfChildren"
            name="number-of-children"
            [label]="translateKey('number_of_children.label')"
            [help]="
              translateKey('number_of_children.help', {
                sizeGroup: item.activity?.meta?.plansMaximumCapacity,
                majorityAge: majorityAge,
              })
            "
            [max]="childrenMaxCapacity"
            data-test="input-counter-child"
          ></app-input-counter>

          <ng-container *ngIf="!isEvent">
            <fieldset
              class="mt-4"
              *ngFor="let child of children.controls; index as childIndex"
              [formGroup]="child"
            >
              <legend class="subscription__form__title">
                {{
                  translateKey('children.name.label', {
                    index: childIndex + 1,
                  })
                }}
              </legend>

              <div class="subscription__form__control__container">
                <!-- Children firstname -->
                <app-form-input-group
                  class="subscription__form__control subscription__form__control--firstname"
                  [label]="translateKey('child.firstname.label')"
                  [errors]="errors('children', 'firstname', childIndex)"
                  errorKey="firstname"
                >
                  <app-form-input
                    #content
                    formControlName="firstname"
                    type="text"
                    [required]="true"
                    [placeholder]="translateKey('child.firstname.placeholder')"
                    data-test="input-firstname-child"
                  ></app-form-input>
                </app-form-input-group>

                <!-- Children lastname -->
                <app-form-input-group
                  class="subscription__form__control subscription__form__control--lastname"
                  [label]="translateKey('child.lastname.label')"
                  [errors]="errors('children', 'lastname', childIndex)"
                  errorKey="lastname"
                >
                  <app-form-input
                    #content
                    formControlName="lastname"
                    type="text"
                    [required]="true"
                    [placeholder]="translateKey('child.lastname.placeholder')"
                    data-test="input-lastname-child"
                  ></app-form-input>
                </app-form-input-group>
              </div>

              <!-- Children Age -->
              <app-form-input-group
                class="subscription__form__control subscription__form__control--age"
                [label]="translateKey('child.age.label')"
                [errors]="errors('children', 'age', childIndex)"
                errorKey="age"
              >
                <app-form-input
                  #content
                  formControlName="age"
                  type="number"
                  [required]="true"
                  [min]="item.activity.ageMin"
                  [max]="majority"
                  [placeholder]="translateKey('child.age.placeholder')"
                  data-test="input-age-child"
                ></app-form-input>
              </app-form-input-group>
            </fieldset>
          </ng-container>
        </div>

        <app-divider class="block my-6"></app-divider>

        <fieldset data-test="tel-input">
          <legend class="subscription__form__title">
            {{ translateKey('contact_phone_number.title') }}
          </legend>

          <p class="text-sm text-grey">
            {{ translateKey('contact_phone_number.description') }}
          </p>

          <app-form-input-group
            class="block mt-4"
            [errors]="phoneNumberErrors"
            [errorKey]="'contact_phone_number'"
            [label]="translateKey('contact_phone_number.label')"
          >
            <app-form-input
              #content
              type="tel"
              formControlName="phoneNumber"
              [placeholder]="translateKey('contact_phone_number.placeholder')"
              [required]="true"
            >
            </app-form-input>
          </app-form-input-group>
        </fieldset>
      </div>

      <app-mobile-fixed-panel [parentElementRef]="elementRef">
        <button
          app-vtmn-play-button
          type="submit"
          class="subscription__form__button"
          [class.w-full]="isMobileDevice"
          [type]="ctaButtonType.Submit"
          [size]="vtmnPlayButtonSize.MEDIUM"
          [shape]="
            isMobileDevice
              ? vtmnPlayButtonShape.SQUARED
              : vtmnPlayButtonShape.ROUNDED
          "
          [disabled]="isSubmitButtonDisabled || isLoading ? true : false"
          [attr.data-disabled]="
            isSubmitButtonDisabled || isLoading ? true : null
          "
          [attr.data-loading]="isLoading ? true : null"
          data-test="input-submit-subscription-form"
        >
          <output *ngIf="isLoading" aria-live="polite" data-part="loading-slot">
            <span
              id=":rk:"
              class="vp-spinner"
              aria-label="Loading..."
              data-part="loading-dots"
            >
              <span></span>
              <span></span>
              <span></span>
            </span>
          </output>
          <span [class.subscription__form__button-text--loading]="isLoading">{{
            getCtaText()
          }}</span>
        </button>
      </app-mobile-fixed-panel>

      <app-tips
        *ngIf="isSharable"
        class="subscription__form__invite-box"
        [title]="translateKey('invite_box.header')"
        [tips]="
          translateKey('invite_box.description')
        "
      >
      </app-tips>

      <app-tips
        *ngIf="showAllowExternalPayment"
        class="subscription__form__information-box"
        [title]="translateKey('information_box.allow_external_payment.header')"
        [tips]="
          translateKey('information_box.allow_external_payment.description')
        "
      ></app-tips>

      <app-tips
        *ngIf="this.item && item?.activity?.isBms"
        class="subscription__form__information-box"
        [title]="translateKey('information_box.header.bms')"
        [tips]="
          translateKey('information_box.description.bms', {
            refundTime: getFormattedRefundTime,
          })
        "
      >
      </app-tips>

      <app-tips
        *ngIf="this.item && !item?.activity?.isBms"
        class="subscription__form__information-box"
        [title]="translateKey('information_box.header')"
        [tips]="
          translateKey('information_box.description', {
            refundTime: getFormattedRefundTime,
          })
        "
      >
      </app-tips>

    </form>
  </div>
</app-checkout-layout>
